import {AuthGuard} from '../router-guards'
import {LoginGuard} from '../router-guards'

export default [{
        path: 'edit/',
        component: () => import( /* webpackChunkName: "account-edit" */ '../../components/account/account-edit.vue'),
        beforeEnter: AuthGuard,
        meta: { accountTopbar: true }
    },
    {
        path: 'billing/',
        component: () => import( /* webpackChunkName: "account-billing" */ '../../components/account/account-billing.vue'),
        beforeEnter: AuthGuard,
        meta: { accountTopbar: true }
    },
    {
        path: 'theme/',
        component: () => import( /* webpackChunkName: "account-theme" */ '../../components/account/account-theme.vue'),
        beforeEnter: AuthGuard,
        meta: { accountTopbar: true }
    },
    {
        path: 'password/change/',
        component: () => import( /* webpackChunkName: "account-password-change" */ '../../components/account/account-password-change.vue'),
        beforeEnter: AuthGuard,
        meta: { accountTopbar: true }
    },
    {
        path: 'password/reset/',
        component: () => import( /* webpackChunkName: "account-password-change" */ '../../components/account/account-password-reset.vue'),
        meta: { noTopbars: true }
    },
    {
        path: 'signup/',
        component: () => import( /* webpackChunkName: "account-signup" */ '../../components/account/account-signup.vue'),
        beforeEnter: LoginGuard,
        meta: { noTopbars: true }
    },
    {
        path: 'login/',
        component: () => import( /* webpackChunkName: "account-login" */ '../../components/account/account-login.vue'),
        beforeEnter: LoginGuard,
        meta: { noTopbars: true }
    }
]